// Internal Imports
import { get, post, put, deleteApi } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;

export const fetchDocMetadataService = docId =>
  new Promise((resolve, reject) => {
    get(`${APIS.DOC_REVVAI_METADATA}/${docId}/metadata/`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => fetchDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const fetchSharedDocMetadataService = (docId, sharingHash) =>
  new Promise((resolve, reject) => {
    get(`${APIS.SHARED_REVVAI_METADATA}/${sharingHash}/docs/${docId}/metadata/`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => fetchSharedDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const addDocMetadataService = (docId, data) =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOC_REVVAI_METADATA}/${docId}/metadata/`, data)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => addDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const addSharedDocMetadataService = (docId, data, sharedHash) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SHARED_REVVAI_METADATA}/${sharedHash}/docs/${docId}/metadata/`,
      data,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => addSharedDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const updateDocMetadataService = (docID, data) =>
  new Promise((resolve, reject) => {
    put(`${APIS.DOC_REVVAI_METADATA}/${docID}/metadata/edit`, data)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => updateDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const updateSharedDocMetadataService = (docID, data, sharedHash) =>
  new Promise((resolve, reject) => {
    put(
      `${APIS.SHARED_REVVAI_METADATA}/${sharedHash}/docs/${docID}/metadata/edit`,
      data,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => updateDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const deleteDocMetadataService = (docID, metaDataId) =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.DOC_REVVAI_METADATA}/${docID}/metadata/${metaDataId}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => deleteDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const deleteSharedDocMetadataService = (docID, metaDataId, sharedHash) =>
  new Promise((resolve, reject) => {
    deleteApi(
      `${APIS.SHARED_REVVAI_METADATA}/${sharedHash}/docs/${docID}/metadata/${metaDataId}`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => deleteSharedDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const downloadDocMetadataService = (docId, format) =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOC_REVVAI_METADATA}/${docId}/metadata/download/${format}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => downloadDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const downloadSharedDocMetadataService = (docId, format, sharedHash) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SHARED_REVVAI_METADATA}/${sharedHash}/docs/${docId}/metadata/download/${format}`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => downloadSharedDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const detectDocMetadataService = docId =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOC_REVVAI_METADATA}/${docId}/metadata/detect`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => detectDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

export const detectSharedDocMetadataService = (docId, sharedHash) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SHARED_REVVAI_METADATA}/${sharedHash}/docs/${docId}/metadata/detect`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.debug(
          `metalensServices => detectSharedDocMetadataService => Error : ${err}`,
        );
        reject(err);
      });
  });

//  Clause Analysis

export const fetchDocAnalysisService = docID =>
  new Promise((resolve, reject) => {
    get(`${APIS.DOC_REVVAI_METADATA}/${docID}/clause-analysis/`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `metalensServices => fetchDocAnalysis => Error : ${error}`,
        );
        reject(error);
      });
  });

export const fetchSharedDocAnalysisService = (docID, sharedHash) =>
  new Promise((resolve, reject) => {
    get(
      `${APIS.SHARED_REVVAI_METADATA}/${sharedHash}/docs/${docID}/clause-analysis/`,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `metalensServices => fetchSharedDocAnalysis => Error : ${error}`,
        );
        reject(error);
      });
  });

export const fetchClauseAnalysisMetaService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.CLAUSE_ANALYSIS_META}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `metalensServices => fetchClauseAnalysisMeta => Error : ${error}`,
        );
        reject(error);
      });
  });

export const provideDocFeedbackService = (docID, componentID, data) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.DOC_REVVAI_METADATA}/${docID}/components/${componentID}/clause-feedback`,
      data,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `metalensServices => provideDocFeedbackService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const provideSharedDocFeedbackService = (
  docID,
  componentID,
  data,
  sharedHash,
) =>
  new Promise((resolve, reject) => {
    post(
      `${APIS.SHARED_REVVAI_METADATA}/${sharedHash}/docs/${docID}/components/${componentID}/clause-feedback`,
      data,
    )
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `metalensServices => provideSharedDocFeedbackService => Error : ${error}`,
        );
        reject(error);
      });
  });

export const metadataBulkDownloadService = (docIDs, format) =>
  new Promise((resolve, reject) => {
    post(`${APIS.DOC_REVVAI_METADATA_BULK}/${format}`, { doc_ids: docIDs })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `metalensServices => metadataBulkDownloadService => Error : ${error}`,
        );
        reject(error);
      });
  });
